module.exports = __webpack_public_path__ + "img/hospital-room-thumb.a70a1c10.jpg";